import classNames from "classnames";
import { Typography } from "PFComponents/typography";

import css from "./warning_tooltip_content.module.scss";

interface WarningTooltipContentProps {
  label: string;
  counter: number;
  classes?: Record<string, string>;
  counterColor: string;
}

const WarningTooltipContent = ({
  label,
  counter,
  classes = {},
  counterColor
}: WarningTooltipContentProps) => {
  const counterValue = counter <= 9 ? counter : "9+";
  return (
    <>
      <div className={css.header}>
        <Typography variant="bodyRegular">{label}</Typography>
        <div style={{ background: counterColor }} className={classNames(css.counter, classes.counter)}>
          {counterValue}
        </div>
      </div>
    </>
  );
};

export default WarningTooltipContent;
